import featureFlags from '@/config/featureFlags'

const PREFIX = 'admin/notification'

const isLoggedIn = () => !!localStorage.getItem('accessToken')

export default {
  async fetchUnreadCount({ commit }) {
    if (!featureFlags.enableAdminInbox || !isLoggedIn()) return 0
    try {
      const res = await this.$http.get(`${PREFIX}/inbox/count`)
      const unreadCount = (res.data && res.data.data && res.data.data.unreadCount) || 0
      commit('SET_UNREAD_COUNT', unreadCount)
      return unreadCount
    } catch (error) {
      return 0
    }
  },

  async fetchInbox({ commit }) {
    if (!featureFlags.enableAdminInbox || !isLoggedIn()) return
    commit('SET_LOADING', true)
    try {
      const res = await this.$http.get(`${PREFIX}/inbox`, { params: { page: 1, limit: 300 } })
      const data = (res.data && res.data.data) || {}
      commit('SET_ITEMS', data.results || [])
      commit('SET_UNREAD_COUNT', data.unreadCount || 0)
      commit('SET_DEFAULT_GURUDWARA_ID', data.defaultGurudwaraId || null)
    } catch (error) {
      commit('SET_ITEMS', [])
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async markRead({ commit }, ids = []) {
    if (!featureFlags.enableAdminInbox || !isLoggedIn()) return
    try {
      await this.$http.post(`${PREFIX}/inbox/mark-read`, { ids })
      if (ids && ids.length) {
        ids.forEach((id) => commit('MARK_ITEM_READ', id))
      } else {
        commit('SET_ITEMS', [])
        commit('SET_UNREAD_COUNT', 0)
      }
    } catch (error) {
      // Keep current UI if mark-read fails
    }
  },

  async fetchQuickCounts({ commit }) {
    if (!featureFlags.enableAdminInbox || !isLoggedIn()) return
    try {
      const res = await this.$http.get(`${PREFIX}/quick-counts`)
      commit('SET_QUICK_COUNTS', (res.data && res.data.data) || {})
    } catch (error) {
      commit('SET_QUICK_COUNTS', {})
    }
  },

  async refresh({ dispatch }) {
    await Promise.all([
      dispatch('fetchUnreadCount'),
      dispatch('fetchInbox'),
      dispatch('fetchQuickCounts')
    ])
  },

  async refreshAll({ dispatch }) {
    const slug = String(localStorage.getItem('roleSlug') || '')
      .toLowerCase()
      .replace(/-/g, '_')
    const isGlobalAdmin = slug === 'admin' || slug === 'support_administrator'
    const tasks = [dispatch('refresh')]
    if (isGlobalAdmin) {
      tasks.push(dispatch('feedback/getUnreadCount', null, { root: true }))
      tasks.push(dispatch('book/getUnreadCount', null, { root: true }))
    }
    await Promise.all(tasks)
  },

  async ensureDefaultGurudwaraId({ state, commit, dispatch }) {
    if (state.defaultGurudwaraId) return state.defaultGurudwaraId
    await dispatch('fetchInbox')
    if (state.defaultGurudwaraId) return state.defaultGurudwaraId
    try {
      const res = await this.$http.get('admin/gurudwara/list', { params: { page: 1, limit: 1 } })
      const results = (res.data && res.data.data && res.data.data.results) || []
      const id = results[0] && results[0]._id
      if (id) commit('SET_DEFAULT_GURUDWARA_ID', id)
      return id || null
    } catch (error) {
      return null
    }
  }
}
